import { useId, useRef, useState } from "react";
import {
  ButtonGroup,
  ClickAwayListener,
  Grow,
  Paper,
  Popper,
  MenuItem,
  MenuList,
} from "@mui/material";
import { ArrowDropDown as DropdownIcon } from "@mui/icons-material";
import Button from "../theme/components/Button.jsx";

export default function DropdownButton({ icon, label, options, onClick }) {
  const [open, setOpen] = useState(false);
  const anchorRef = useRef(null);
  const id = useId();

  const handleMenuItemClick = (event, index, option) => {
    if (typeof option?.onClick === "function") {
      option.onClick(event, index, option);
    } else if (typeof onClick === "function") {
      onClick(event, index, option);
    }

    setOpen(false);
  };

  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen);
  };

  const handleClose = (event) => {
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return;
    }

    setOpen(false);
  };

  return (
    <>
      <ButtonGroup ref={anchorRef} aria-label="Button mit Dropdown-Menü">
        <Button
          startIcon={icon}
          size="small"
          aria-controls={open ? id : undefined}
          aria-expanded={open ? "true" : undefined}
          aria-haspopup="menu"
          onClick={handleToggle}
          endIcon={<DropdownIcon />}
        >
          {label}
        </Button>
      </ButtonGroup>
      <Popper
        sx={{ zIndex: 1 }}
        open={open}
        anchorEl={anchorRef.current}
        role={undefined}
        transition
        disablePortal
      >
        {({ TransitionProps, placement }) => (
          <Grow
            {...TransitionProps}
            style={{
              transformOrigin:
                placement === "bottom" ? "center top" : "center bottom",
            }}
          >
            <Paper>
              <ClickAwayListener onClickAway={handleClose}>
                <MenuList id={id} autoFocusItem>
                  {options.map((option, index) => (
                    <MenuItem
                      key={index}
                      onClick={(event) =>
                        handleMenuItemClick(event, index, option)
                      }
                    >
                      {option?.label}
                    </MenuItem>
                  ))}
                </MenuList>
              </ClickAwayListener>
            </Paper>
          </Grow>
        )}
      </Popper>
    </>
  );
}
